module.exports = __webpack_public_path__ + "img/a2.591d5820.png";